import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';
import { StyledInputProps } from './Input.types';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: 'Open Sans';
`;

export const LabelWrapper = styled.div`
  margin-bottom: ${rem(10)};
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
`;

export const StyledLabel = styled.label`
  margin-right: ${rem(8)};
  font-weight: 600;
  font-size: ${rem(14)};
`;

export const HelpText = styled.div`
  color: ${({ theme }) => theme.colors.gray600};
  font-size: ${rem(12)};
`;

export const StyledInput = styled.input<StyledInputProps>`
  border: 1px solid ${({ theme, errorText }) => (errorText ? theme.colors.red : theme.colors.gray600)};
  background-color: ${({ theme, errorText }) => (errorText ? theme.colors.redOpacity03 : theme.colors.white)};
  border-radius: ${rem(8)};
  padding: ${rem(8)} ${rem(16)} ${rem(8)} ${rem(16)};
  margin-bottom: ${rem(6)};
  font-weight: 400;
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.gray900};
  font-family: 'Open Sans';
  line-height: ${rem(22)};

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.gray900};
    box-shadow: 0px 2px 4px rgba(19, 19, 19, 0.5);
  }

  &:disabled {
    border: 1px solid ${({ theme }) => theme.colors.gray400};
    background-color: ${({ theme }) => theme.colors.gray100};
    color: ${({ theme }) => theme.colors.gray600};
  }
`;

export const ErrorText = styled.div<StyledInputProps>`
  color: ${({ theme }) => theme.colors.red};
  font-weight: 400;
  font-size: ${rem(12)};
  margin-top: ${({ characterLimit }) => (characterLimit ? rem(4) : '')};
`;

export const SuccessText = styled.div<StyledInputProps>`
  color: ${({ theme }) => theme.colors.green};
  font-weight: 400;
  font-size: ${rem(12)};
`;
